module.exports = __webpack_public_path__ + "src/assets/img/sprites.24f522dc.png";